import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchWorkoutPreference = async (ClientId) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.Get_Workout_Preference}/${ClientId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data || "Failed to fetch workout preference detail"
    );
  }
};

export const updateWorkoutPreference = async ({ workoutPreferenceData }) => {
  const response = await axiosInstance.post(
    Endpoints.UPDATE_WORKOUT_PREFERENCE,
    workoutPreferenceData
  );
  return response.data;
};

export const postWorkoutPlan = async (workoutPlanData) => {
  const response = await axiosInstance.post(
    Endpoints.POST_WORKOUT_PLAN,
    workoutPlanData
  );
  return response.data;
};
